var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_3575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5913 40.0001C30.0513 40.0001 27.1758 37.1383 27.1758 33.615C27.1758 30.0918 30.0513 27.23 33.5913 27.23C37.1314 27.23 40.0068 30.0918 40.0068 33.615C40.0068 37.1383 37.1314 40.0001 33.5913 40.0001ZM33.5913 31.323C32.3214 31.323 31.2883 32.3511 31.2883 33.615C31.2883 34.879 32.3214 35.9071 33.5913 35.9071C34.8613 35.9071 35.8943 34.879 35.8943 33.615C35.8943 32.3511 34.8613 31.323 33.5913 31.323Z",
    fill: "#2650FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2023 0C22.5502 0 18.7601 3.64768 18.7601 8.1336V30.3012C18.7601 32.5278 16.819 34.3418 14.4305 34.3418C12.0419 34.3418 10.1008 32.5278 10.1008 30.3012V13.9358H5.98828V30.3012C5.98828 34.7872 9.7718 38.4348 14.4305 38.4348C19.0891 38.4348 22.8726 34.7872 22.8726 30.3012V8.1336C22.8726 5.90701 24.8137 4.09299 27.2023 4.09299C29.5908 4.09299 31.532 5.90701 31.532 8.1336V24.499H35.6445V8.1336C35.6445 3.64768 31.861 0 27.2023 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1201 1.40944L-0.00366211 9.49463L2.64842 12.1341L10.7722 4.04893L8.1201 1.40944Z",
    fill: "#FFBC07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.45918 4.0508L13.4434 11.9971L16.0954 9.35758L8.11127 1.41131L5.45918 4.0508Z",
    fill: "#FFBC07"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_3575"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.dd067acaa8642f63f4fef735fabe921f.svg";
export { ForwardRef as ReactComponent };